import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import Header from "../../../Common/Header/Header";
import SideBar from "../../../Common/SideBar/SideBar";
import OrderCancel from "../../components/OrderCancel";
import OrderComplete from "../../components/OrderComplete";
import OrderInDeliver from "../../components/OrderInDeliver";
import OrderInProcess from "../../components/OrderInProcess";
import OrderReceived from "../../components/OrderReceived";
import DeliveryOrders from "../../components/DeliveryOrders";
import "./Ecom.css";

const Ecom = () => {
  return (
    <div className="ecom-container">
      <div className="container-fluid  bg-white">
        <div className="row">
          <div className="col-md-2 ">
            <SideBar />
          </div>
          <div className="col-md-10">
            <Header title="Ecom Sale" />
            <div className="bg-white">
              <Tabs
                defaultActiveKey="received-order"
                id="ecom-tabs"
                className="custom-tabs "
              >
                <Tab 
                  eventKey="received-order" 
                  title="New Orders"
                  className="tab-content-wrapper"
                >
                  <OrderReceived />
                </Tab>
                <Tab 
                  eventKey="order-process" 
                  title="Orders In Process"
                  className="tab-content-wrapper"
                >
                  <OrderInProcess />
                </Tab>
                <Tab 
                  eventKey="complete-process" 
                  title="Complete"
                  className="tab-content-wrapper"
                >
                  <OrderComplete />
                </Tab>
                <Tab 
                  eventKey="cancel-orders" 
                  title="Cancel Orders"
                  className="tab-content-wrapper"
                >
                  <OrderCancel />
                </Tab>
                <Tab 
                  eventKey="deliveryOrders" 
                  title="Delivery Orders"
                  className="tab-content-wrapper"
                >
                  <DeliveryOrders />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ecom;
